import {
    SelectSearchOption
} from '../../dave-utils-module/select-search/components/select-search/select-search.component';
import { GRPCEntityBase } from '../helper/helper';
import { DepartmentResponseObject } from '@dave/types/dist/proto/baseService/department';
import { GetTimeFromTimestamp } from '@dave/types';



export class DepartmentEntity implements GRPCEntityBase<DepartmentResponseObject, DepartmentEntity>, SelectSearchOption {
    static fromBackend = (res: DepartmentResponseObject): DepartmentEntity => {
        return new DepartmentEntity(
            +res.Id,
            res.Name,
            res.Spartennummer,
            // UserId?: string | undefined;
            // PartnerId: string | undefined;
            res.PartnerOfficeId ? +res.PartnerOfficeId : null,
            // CreatedAt: string;
            GetTimeFromTimestamp(+res.UpdatedAt),
            res.DeletedAt ? GetTimeFromTimestamp(+res.DeletedAt) : null,
            // AdditionalData?: string | undefined;
        );
    };
    static PropertyNames: Record<keyof Omit<DepartmentEntity, 'Id' | 'UpdatedAt' | 'DeletedAt' | 'optionLabel'| 'Clone'>, string> = {
        'Name': 'Name',
        'Spartennummer': 'Spartennummer',
        'PartnerOfficeId': 'Unternehmen'
    }
    get optionLabel() {
        return this.Name;
    }
    constructor(
        public Id: number = null,
        public Name: string = null,
        public Spartennummer: string = null,
        // public UserId?: string | undefined = null,
        // public PartnerId: string | undefined = null,
        public PartnerOfficeId: number | null = null,
        // public CreatedAt: string = null,
        public UpdatedAt: Date = null,
        public DeletedAt: Date | null = null,
        // public AdditionalData?: string | undefined = null,
    ) {}
    Clone(override: Partial<DepartmentEntity> = {}): DepartmentEntity {
        const attr = { ...this, ...override };
        return Object.assign(new DepartmentEntity(), attr);
    }

}
